import { useMutation, useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Badge, Card, Spinner } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  Row,
  PaginationComponent
} from "../../../components/Component";

import { loginAxios } from '../../../config/axios.config';
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import './style.scss';

import TableHead from "../common/TableHead";

const ProductCard = () => {

  const dispatch = useDispatch();
  const history = useHistory();

  const formSubmitSuccess = useSelector((state) => state.profileReducer.formSubmitSuccess);

  const [currentPage, setCurrentPage] = useState(1);
  // const [itemPerPage] = useState(8);
  const [itemPerPage, setItemPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState('');

  const [onSearchText, setSearchText] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);

  const [productList, setProductList] = useState([]);


  const [searchData, setSearchData] = useState({ product_title: '', product_id: '',  designer_code: '', status: '' });

  
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { errors, register, handleSubmit } = useForm();


  const getProducts = async () => {
    try {
      const { data } = await loginAxios.get(`designers/product-catalogue`, {
        headers: {
          'x-auth-token': localStorage.getItem('accessToken')
        }
      });
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  const { isFetching, isLoading, error, isSuccess, isError, data, refetch } = useQuery(['getProducts'], getProducts, {
    // refetchOnMount: false,
    refetchOnWindowFocus: false,
    onSettled(data, error) {
      if (data) {
        setTotalCount(data?.data?.totalCount);
        setProductList(data.data.products_listing)
      }
    }
  })


  useEffect(() => {


    if (formSubmitSuccess == true) {

      toast.success("Your details are submitted for approval", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        progress: false,
        onClose: () => {
          dispatch({ type: 'FORM_SUBMIT_SUCCESS', payload: false })
        }
      });
    }

  }, [formSubmitSuccess]);




  const exportProducts = async (params) => {
    try {
      const { data } = await loginAxios.post(`designers/export_product_data`, params, {
        headers: {
          'x-auth-token': localStorage.getItem('accessToken')
        }
      });
      return data;

    } catch (error) {
      return Promise.reject(error);
    }
  };

  const exportProductsCall = useMutation(exportProducts, {
    onSettled(data, error) {
      if (data) {
        // console.log(data?.data?.file_path)
        // window.open(`${data?.data?.file_path}`, "_blank")

        // toast.success(data?.message, {
        //   position: "top-right",
        //   autoClose: 2000,
        //   hideProgressBar: true,
        //   closeOnClick: true,
        //   progress: false,
        // });


        if (data?.data?.file_path) {
          window.open(`${data?.data?.file_path}`, "_blank")

          toast.success(data?.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            progress: false,
          });
        } else {

          toast.error(data?.data?.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            progress: false,
          });

        }

      } else if (error) {
        console.log('found ERROR');

        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          progress: false,
        });
      }
    }
  });

  const handleExport = () => {
    // exportProductsCall.mutate();
    history.push('product-export-listing')
  }




























  const exportInventory = async (params) => {
    try {
      const { data } = await loginAxios.post(`designers/export_consignment_inventory`, params, {
        headers: {
          'x-auth-token': localStorage.getItem('accessToken')
        }
      });
      return data;

    } catch (error) {
      return Promise.reject(error);
    }
  };

  const exportInventoryCall = useMutation(exportInventory, {
    onSettled(data, error) {
      if (data) {
        // console.log(data?.data?.file_path)
        if (data?.data?.file_path) {
          window.open(`${data?.data?.file_path}`, "_blank")

          toast.success(data?.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            progress: false,
          });
        } else {

          toast.error(data?.data?.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            progress: false,
          });

        }


      } else if (error) {
        console.log('found ERROR');


        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          progress: false,
        });
      }
    }
  });

  const handleExportInventory = () => {
    exportInventoryCall.mutate();
  }











  const searchProduct = async (params) => {
    try {
      const { data } = await loginAxios.get(`designers/product-catalogue?product_title=${params.product_title}&product_id=${params.product_id}&designer_code=${params.designer_code}&status=${params.status}&offset=${params.offsetItem}&limit=${params.itemPerPage}`, {
        headers: {
          'x-auth-token': localStorage.getItem('accessToken')
        }
      });
      return data;

    } catch (error) {
      return Promise.reject(error);
    }
  };

  const searchProductCall = useMutation(searchProduct);






  let seachFeild = {
    product_title: '',
    product_id: '',
    designer_code: '',
    status: '',
  };


  const productStatusArr = [
    { label: 'Inactive', value: 'inactive' },
    { label: 'Active', value: 'active' }
  ];

  const seachFeildType = {

    product_title: {
      tag: "input",
      type: "text",
    },
    product_id: {
      tag: "input",
      type: "text",
    },
    designer_code: {
      tag: "input",
      type: "text",
    },

    status: {
      tag: "dropdown",
      options: productStatusArr,
      optionName: 'Status'
    },

  };


  const handleGetData = () => {
    console.log('DATA success handleGetData')
    refetch();
  }





  // const searchHandler = async (data) => {

  //   console.log(data);

  //   var payload = {
  //     product_title: data.product_title,
  //     product_id: data.product_id,
  //     designer_code: data.designer_code,
  //     status: data?.status?.value ? data?.status?.value : '',
  //     offsetItem: indexOfFirstItem,
  //     itemPerPage
  //   }

  //   searchProductCall.mutate(payload, {
  //     onSettled(data, error) {
  //       if (data) {
  //         console.log(data.data);
  //         setProductList(data.data.products_listing);
  //       } else {
  //         console.log(error);
  //       }
  //     }
  //   });

  // };


  const searchHandler = async (data) => {
    setCurrentPage(1);
    setSearchData(data);
  };


  useEffect(async () => {

    console.log(itemPerPage);

    const indexOfLastItem = currentPage * itemPerPage;
    const indexOfFirstItem = indexOfLastItem - itemPerPage;

    var payload = {
      product_title: searchData?.product_title,
      product_id: searchData?.product_id,
      designer_code: searchData?.designer_code,
      status: searchData?.status?.value ? searchData?.status?.value : '',
      offsetItem: indexOfFirstItem,
      itemPerPage
    }

    searchProductCall.mutate(payload, {
      onSettled(data, error) {
        if (data) {
          console.log(data.data);
          setTotalCount(data?.data?.totalCount);
          setProductList(data.data.products_listing);
        } else {
          console.log(error);
        }
      }
    });

  }, [itemPerPage, currentPage, searchData]);

 
  return (
    <React.Fragment>
      <Head title="Product List"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Products List</BlockTitle>
            </BlockHeadContent>
            {productList?.length > 0 &&
              <BlockHeadContent>
                <button className="btn btn-primary mr-3" onClick={handleExportInventory} disabled={exportInventoryCall.isLoading ? true : false}>
                  {exportInventoryCall.isLoading ? <Spinner color="light" size='sm' /> : <Icon name="download" />}
                  <span>Consignment stock at Aza</span>
                </button>

                {/* <button className="btn btn-primary" onClick={handleExport} disabled={exportProductsCall.isLoading ? true : false}>
                  {exportProductsCall.isLoading ? <Spinner color="light" size='sm' /> : <Icon name="download" />}
                  <span>Product Export</span>
                </button> */}

                <button className="btn btn-primary" onClick={handleExport}>
                  <span>Product Export</span> <Icon name="arrow-right"></Icon>
                </button>
              
              </BlockHeadContent>
            }
          </BlockBetween>
        </BlockHead>
        <Block>

          <TableHead
            searchHandler={searchHandler}
            searchFieldData={seachFeild}
            seachFeildType={seachFeildType}
            reloadHandler={() => {
              handleGetData();
            }}
            setSearchText={setSearchText}
            setSelectedItems={setSelectedItems}
            pageName="purchase-order-listing"
          />

          <Row className="g-gs">
            {productList.length > 0 ? (
              productList.map((item) => {
                return (
                  <Col xxl={3} lg={3} sm={6} key={item.id}>
                    <Card className="product-card">
                      <div className="product-thumb">
                        <Link to={`${process.env.PUBLIC_URL}/product-catalogue-details/${item.productID}`}>
                          <img className="card-img-top" src={item.productThumbImg} alt="" />
                        </Link>
                        <ul className="product-badges">
                          {item.is_product_active === 0 ? <li>
                            <Badge color="danger">Inactive</Badge>
                          </li>
                            : <li>
                              <Badge color="success">Active</Badge>
                            </li>
                          }
                        </ul>

                        <ul className="product-badges-bottm">
                          <li>
                            <Badge className="badge-color-new">Product ID: {item.productID}</Badge>
                          </li>
                          <li>
                            <Badge className="badge-color-new">Designer Code: {item.designerCode}</Badge>
                          </li>
                        </ul>

                      </div>
                      {/* <div className="card-inner text-center"> */}
                      <div className="text-center title-head-text">
                        <ul className="product-tags product-card-title">
                          <li>
                            <Link to={`${process.env.PUBLIC_URL}/product-catalogue-details/${item.productID}`}>{item.productTitle}</Link>
                          </li>
                        </ul>
                        <h5 className="product-title">
                          <Link to={`${process.env.PUBLIC_URL}/product-catalogue-details/${item.productID}`}></Link>
                        </h5>
                      </div>
                    </Card>
                  </Col>
                );
              })
            ) : (
              <div className="ml-2">No product found</div>
            )}
          </Row>
      
          <div className="card-inner">
                  {productList.length > 0 ? (                    
                    <PaginationComponent
                      itemPerPage={itemPerPage}                      
                      totalItems={totalCount || []}
                      paginate={paginate}
                      currentPage={currentPage}                      
                      setItemPerPage={setItemPerPage}
                      setCurrentPage={setCurrentPage}                                            
                    />
                  ) : (
                    <div className="text-center">
                      <span className="text-silent">No data found</span>
                    </div>
                  )}
                </div>

        </Block>
      </Content>
      <ToastContainer />
    </React.Fragment>
  );
};
export default ProductCard;
